module.exports = __webpack_public_path__ + "static/media/What are the benefits and importance of Stage-wise Templated Invoices.b3c4de8f.png";